import React from 'react';
import AppMenu from './AppMenu';
import { Collapse } from 'reactstrap';

const Navbar = props => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "topnav"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "navbar navbar-dark navbar-expand-lg topnav-menu"
  }, /*#__PURE__*/React.createElement(Collapse, {
    isOpen: props.isMenuOpened,
    className: "navbar-collapse",
    id: "topnav-menu-content"
  }, /*#__PURE__*/React.createElement(AppMenu, {
    mode: 'horizontal'
  }))))));
};

export default Navbar;